import type React from 'react';
import { useRef } from 'react';
import { Paragraph } from '../../../components';
import './blockSourceButton.less';
import IcoTable from '../../icon/icons/IcoTable';
import { useDrag } from 'react-dnd';
import IcoPricingTable from '../../icon/icons/IcoPricingTable.tsx';
import IcoDrag from '../../icon/icons/IcoDrag.tsx';

interface TableBlockButtonProps {
  title: string;
  testId?: string;
  isPricingTable?: boolean;
  isCurrencySettingsEnabled?: boolean;
  onClickAdd?: () => void;
}

const TableBlockButton: React.FunctionComponent<TableBlockButtonProps> = ({
  title,
  isPricingTable,
  isCurrencySettingsEnabled,
  testId,
  onClickAdd,
}) => {
  const wasDraggingRef = useRef(false);
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'TABLE',
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    item: () => {
      wasDraggingRef.current = true;
      return { title, isPricingTable, isCurrencySettingsEnabled };
    },
    end: () => {
      requestAnimationFrame(() => {
        wasDraggingRef.current = false;
      });
    },
  }));
  const renderedIcon = isPricingTable ? <IcoPricingTable /> : <IcoTable />;
  const handleClick = () => {
    if (wasDraggingRef.current) {
      return;
    }

    onClickAdd?.();
  };
  return (
    <button
      data-testid={testId}
      ref={drag}
      draggable
      className="block-source"
      style={{ opacity: isDragging ? 0.5 : 1 }}
      onClick={handleClick}
    >
      <div className="block-source-static-icon block-source-icon">{renderedIcon}</div>
      <div className="block-source-drag-icon">
        <IcoDrag />
      </div>
      <Paragraph className="block-source__title" size="sm">
        {title}
      </Paragraph>
    </button>
  );
};

export default TableBlockButton;
TableBlockButton.displayName = 'TableBlockButton';
